/* faith-product-altar.js — Product Altar interactions.
   - Thumbnail clicks switch the active stage image.
   - Variant radios swap the visual is-active state + update price display.
   - Form submits via Shopify's standard /cart/add POST. */

(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-faith-altar]').forEach(setupAltar);
  }

  function setupAltar(root) {
    setupThumbs(root);
    setupVariants(root);
    setupSticky(root);
  }

  // ── Phone-only sticky Add to Cart: shown while the main button is off screen ──
  function setupSticky(root) {
    var bar = root.querySelector('[data-altar-sticky]');
    var cta = root.querySelector('[data-altar-cta]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;

    var btn = bar.querySelector('button');
    var mq = window.matchMedia('(max-width: 899px)');
    var ctaOnScreen = true;

    function update() {
      var show = mq.matches && !ctaOnScreen;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
      document.documentElement.style.setProperty('--faith-bottom-offset', show ? bar.offsetHeight + 'px' : '0px');
      document.documentElement.classList.toggle('faith-has-sticky-atc', show);
    }

    new IntersectionObserver(function (entries) {
      ctaOnScreen = entries[0].isIntersecting;
      update();
    }).observe(cta);

    if (mq.addEventListener) mq.addEventListener('change', update);
    else if (mq.addListener) mq.addListener(update);
  }

  // ── Thumbnail → stage ──
  function setupThumbs(root) {
    var thumbs = root.querySelectorAll('.faith-altar__thumb');
    var slides = root.querySelectorAll('.faith-altar__slide');
    if (thumbs.length < 2) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.dataset.thumbIndex, 10);
        if (isNaN(i)) return;

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        slides.forEach(function (s) { s.classList.remove('is-active'); });

        btn.classList.add('is-active');
        var target = root.querySelector('.faith-altar__slide[data-slide-index="' + i + '"]');
        if (target) target.classList.add('is-active');
      });
    });
  }

  // ── Variant picker ──
  function setupVariants(root) {
    var variants = root.querySelectorAll('.faith-altar__variant');
    var priceEl  = root.querySelector('.faith-altar__price');
    var cta      = root.querySelector('[data-altar-cta]');
    if (variants.length < 2) return;

    variants.forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');
      if (!input) return;

      input.addEventListener('change', function () {
        variants.forEach(function (v) { v.classList.remove('is-active'); });
        label.classList.add('is-active');

        if (priceEl && label.dataset.variantPrice) {
          priceEl.firstChild.textContent = formatMoney(parseInt(label.dataset.variantPrice, 10));
        }

        if (cta) {
          var available = label.dataset.variantAvailable === 'true';
          cta.disabled = !available;
          cta.querySelector('.faith-altar__cta-label').textContent = available ? defaultCtaLabel(cta) : 'Reserved';
        }
      });
    });
  }

  // Minimal cents → "$X.XX" formatter; matches Shopify's default money_format
  // closely enough for in-page swaps. The server-rendered initial price still
  // honors the shop's exact format.
  function formatMoney(cents) {
    if (isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function defaultCtaLabel(cta) {
    return cta.dataset.defaultLabel || cta.querySelector('.faith-altar__cta-label').textContent.trim() || 'Add to Cart';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
